module.exports = __webpack_public_path__ + "static/media/preventivo_amarillo.7de9477b.svg";